import { formatDate } from "../../utils/date";

export const formatDateRange = (dateStartStr: string, dateEndStr: string) => {
    // Создаем объекты Date из строк
    const startDate = new Date(dateStartStr);
    const endDate = new Date(dateEndStr);

    const formattedStart = formatDate(startDate);
    const formattedEnd = formatDate(endDate);

    // Если даты одинаковые, возвращаем одну дату
    if (formattedStart === formattedEnd) {
        return formattedStart;
    }

    // Если разные - возвращаем диапазон
    return `${formattedStart} - ${formattedEnd}`;
};

export const formatTimeToHoursMinutes = (timeStr: string, lang?: string) => {
    const [h, m] = timeStr.split(':').map(Number);
    const parts = [];

    const hoursName = lang === 'ru' ? 'ч.' : 'h.'
    const minutesName = lang === 'ru' ? 'мин.' : 'min.'

    if (h > 0) parts.push(`${h} ${hoursName}`);
    if (m > 0) parts.push(`${m} ${minutesName}`);

    return parts.length > 0 ? parts.join(' ') : `0 ${minutesName}`;
};
